<template>
  <div id="home">
    <vue-headful :title="$store.state.option['home_title-' + lang]" :lang="lang" />
    <div id="homeSlide" class="pr">
      <div class="show-desktop" style="position: absolute;bottom:0px;width:100%;">
        <div id="slideSearch">
          <div class="pr row bordaSearch" style="z-index:2;background: rgb(242,242,242);padding:15px 15px 0px 15px;">
            <h3 class="text-uppercase w-100 text-center">{{$store.state.option['pesquisar-' + lang]}}</h3>
            <div class="col-lg-6 col-md-6 col-sm-4 p-v-5">
              <select required class="form-control" v-model="form.levantamento" @change="form.entrega = form.levantamento">
                <option value="" disabled selected hidden>{{$store.state.option['levantamento-' + lang]}}</option>
                <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
              </select>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-4 p-v-5">
              <select class="form-control" v-model="form.entrega" >
                <option value="" disabled selected hidden>{{$store.state.option['devolucao-' + lang]}}</option>
                <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
              </select>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-4 p-v-5">
              <date-picker value-type="timestamp" required v-model="form.date" @change="handleChangeDate" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :disabled-date="notBeforeDate" :lang="langData" :placeholder="$store.state.option['levantamento_data-' + lang]"></date-picker>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-4 p-v-5">
              <date-picker required v-model="form.time" :open.sync="open" @change="handleChange" :clearable="false" :editable="false" type="time" format="HH:mm" :minute-step="10" :placeholder="$store.state.option['levantamento_hora-' + lang]"></date-picker>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-4 p-v-5">
              <date-picker value-type="timestamp" required v-model="form.date1" :disabled-date="notBeforeDate1" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :placeholder="$store.state.option['devolucao_data-' + lang]"></date-picker>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-4 p-v-5">
              <date-picker required v-model="form.time1" :clearable="false" :editable="false" type="time" format="HH:mm" :minute-step="10" :placeholder="$store.state.option['devolucao_hora-' + lang]" :open.sync="open1" @change="handleChange1"></date-picker>
            </div>

            <div :class="{'col-lg-12 col-md-12': form.driver !== 'add', 'col-lg-6 col-md-6 col-sm-4': form.driver === 'add', 'p-v-5': 1}" v-if="$store.state.user">
              <select id="driver" v-model="form.driver" class="form-control" v-if="$store.state.user.role === 'client'" @change="setDriversBirthDay(form.driver)">
                <option selected value="">{{$store.state.option['reserved-seleccionarCondutor-' + lang]}}</option>
                <option :value="dt.DriverID" v-for="(dt, index) in drivers" :key="index">{{dt.Driver_Name}} ({{dt.City}})</option>
                <option value="add">{{$store.state.option['reserved-add-driver-' + lang]}}</option>
              </select>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-4 p-v-5" v-if="form.driver === 'add'">
              <input type="text" class="form-control" v-model="form.condutor" :placeholder="$store.state.option['reserved-nome-condutor-' + lang]" />
            </div>
            <div class="col-lg-12 p-v-5 row" style="margin:0px;" v-if="!$store.state.user || form.driver === 'add'">
              <div class="col-lg-6 col-md-6">
                <label style="margin-top:7px;float:right;">{{$store.state.option['aniversario-' + lang]}}</label>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-4" style="padding-right:0px;">
                <input type="text" class="form-control" v-model="form.aniversario" :placeholder="$store.state.option['date_of_Birth-' + lang]" v-mask="date_mask_local" />
              </div>
            </div>
            <div class="text-center pr col-lg-12 col-md-12" style="top:15px;">
              <button @click="reservar()" style="padding:10px 50px" type="button" class="btn-lg btn btn-primary sembordas">{{$store.state.option['search_botao-' + lang]}} <i class="fas fa-search m-l-15"></i></button>
            </div>
          </div>
        </div>
      </div>
      <b-carousel id="carousel-1" v-model="slide" :interval="4000" background="#ababab" style="text-shadow: 1px 1px 2px #333;" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">
        <b-carousel-slide :img-src="'/images/' + dt" v-for="(dt, index) in slideshow" :key="index" ></b-carousel-slide>
      </b-carousel>
    </div>
    <div class="show-mobile">
        <div>
          <div class="pr row bordaSearch" style="z-index:2;background: rgb(242,242,242);padding:30px 15px;">
            <h3 class="text-uppercase w-100 text-center">{{$store.state.option['pesquisar-' + lang]}}</h3>
            <div class="col-lg-6 col-md-4 col-sm-4 p-v-5">
              <select required class="form-control" v-model="form.levantamento" @change="form.entrega = form.levantamento">
                <option value="" disabled selected hidden>{{$store.state.option['levantamento-' + lang]}}</option>
                <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
              </select>
            </div>

            <div class="col-lg-6 col-md-4 col-sm-4 p-v-5">
              <date-picker value-type="timestamp" required v-model="form.date" @change="handleChangeDate" :disabled-date="notBeforeDate" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :minute-step="10" :placeholder="$store.state.option['levantamento_data-' + lang]"></date-picker>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-4 p-v-5">
              <date-picker required v-model="form.time" :open.sync="open2" @change="handleChange2" :clearable="false" :editable="false" type="time" format="HH:mm" :minute-step="10" :placeholder="$store.state.option['levantamento_hora-' + lang]"></date-picker>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-4 p-v-5">
              <select class="form-control" v-model="form.entrega" >
                <option value="" disabled selected hidden>{{$store.state.option['devolucao-' + lang]}}</option>
                <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
              </select>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-4 p-v-5">
              <date-picker value-type="timestamp" required v-model="form.date1" :disabled-date="notBeforeDate1" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :minute-step="10" :placeholder="$store.state.option['devolucao_data-' + lang]"></date-picker>
            </div>
            <div class="col-lg-6 col-md-4 col-sm-4 p-v-5">
              <date-picker required v-model="form.time1" :clearable="false" :editable="false" type="time" format="HH:mm" :minute-step="10" :placeholder="$store.state.option['levantamento_hora-' + lang]" :open.sync="open3" @change="handleChange3"></date-picker>
            </div>
            <div class="col-lg-12 col-md-6 p-v-5" v-if="$store.state.user">
              <select id="driver" v-model="form.driver" class="form-control" v-if="$store.state.user.role === 'client'" @change="setDriversBirthDay(form.driver)">
                <option selected value="">{{$store.state.option['reserved-seleccionarCondutor-' + lang]}}</option>
                <option :value="dt.DriverID" v-for="(dt, index) in drivers" :key="index">{{dt.Driver_Name}} ({{dt.City}})</option>
                <option value="add">{{$store.state.option['reserved-add-driver-' + lang]}}</option>
              </select>
            </div>
            <div class="col-lg-12 col-md-6 p-v-5" v-if="form.driver === 'add'">
              <input type="text" class="form-control" v-model="form.condutor" :placeholder="$store.state.option['reserved-nome-condutor-' + lang]" />
            </div>
            <div class="col-lg-12 p-v-5 row" style="margin:0px;" v-if="!$store.state.user || form.driver === 'add'">
              <div class="col-lg-6 col-md-8">
                <label style="margin-top:7px;float:right;">{{$store.state.option['aniversario-' + lang]}}</label>
              </div>
              <div class="col-lg-6 col-md-4" style="padding-right:0px;">
                <input type="text" class="form-control" v-model="form.aniversario" :placeholder="$store.state.option['date_of_Birth-' + lang]" v-mask="date_mask_local"/>
                <!-- :placeholder="setDatesPlaceholder" -->
                <!-- pattern="[12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])"  -->
              </div>
            </div>

            <div class="text-center pr col-lg-12 col-md-12" style="top:15px;">
              <button @click="reservar()" style="padding:10px 50px" type="button" class="btn-lg btn btn-primary sembordas">{{$store.state.option['search_botao-' + lang]}} <i class="fas fa-search m-l-15"></i></button>
            </div>
          </div>
        </div>
      </div>

    <div class="bordaSlideshow"></div>

    <div id="frota" class="container p-50" v-if="cars.length">
      <div class="container1 pr text-center">
        <div class="barra"></div>
        <h2 class="text-center text-uppercase laranja p-t-20 z-10 pr b-branco titulo preto">{{$store.state.option['nossa_frota-' + lang]}}</h2>
      </div>
      <vueper-slides :bullets="false" class="no-shadow" :visible-slides="4" slide-multiple :slide-ratio="1/4" :dragging-distance="200" :breakpoints="{ 500: { visibleSlides: 1 }, 800: { visibleSlides: 2 }, 1000: { visibleSlides: 3 } }">
        <vueper-slide v-for="(dt, index) in cars" :key="index">
          <div class="text-center pr box" slot="slideContent">
            <div style="height:176px;">
              <router-link to="reserved"><img :src="dt.imageURL ? dt.imageURL : '/img/img.png'" style="max-height:176px;max-width:100%;" /></router-link>
            </div>
            <div class="clearfix"></div>
            <h5 class="card-title m-0">{{dt.brand}} {{dt.model}}</h5>
            <p class="card-text">{{dt.group_Name}}</p>

            <div class="text-center p-t-5">
              <span class="car-icon bg-icon_driver">{{dt.seats}}</span>
              <span class="car-icon bg-icon_door">{{dt.doors}}</span>
              <span class="car-icon bg-icon_bag">{{dt.suitcases}}</span>
              <span class="car-icon bg-icon_transmissao text-uppercase" v-if="dt.automaticTransmission == true">{{$store.state.option['automatic-' + lang][0]}}</span>
              <span class="car-icon bg-icon_transmissao text-uppercase" v-else>{{$store.state.option['manual-' + lang][0]}}</span>
            </div>

            <div class="clearfix m-t-10"></div>
            <router-link class="btn btn-primary btn-block text-uppercase box-a" to="/reserved">{{$store.state.option['reservar-' + lang]}} <i class="far fa-check-circle"></i></router-link>
          </div>
        </vueper-slide>
      </vueper-slides>
    </div>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import { mapMutations } from 'vuex'
import 'vueperslides/dist/vueperslides.css'
import birthDate from '../mixins/birthDate'

export default {
  components: { VueperSlides, VueperSlide },
  mixins: [birthDate],
  data () {
    return {
      slide: 0,
      sliding: null,
      slideshow: [],
      cars: [],
      estacoes: {},

      form: {
        date: '',
        date1: '',
        time: new Date('2000/10/10 10:00:00'),
        time1: new Date('2000/10/10 10:00:00'),
        levantamento: '',
        entrega: '',
        aniversario: '',
        driver: '',
        condutor: ''
      },
      langData: {},
      lang: '',
      width: window.innerWidth,
      open: false,
      open1: false,
      open2: false,
      open3: false,
      drivers: [],
      date_mask_local: '####-##-##',
      formattedBirthDate: ''
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_AVISO'
    ]),
    handleChangeDate () {
      let d = new Date(this.form.date)
      d.setDate(d.getDate() + 7)
      this.form.date1 = new Date(d).getTime()
    },
    notBeforeDateAniversario (date) {
      return date > new Date()
    },
    handleChange (value, type) {
      if (type === 'minute') {
        this.open = false
      }
    },
    handleChange1 (value, type) {
      if (type === 'minute') {
        this.open1 = false
      }
    },
    handleChange2 (value, type) {
      if (type === 'minute') {
        this.open2 = false
      }
    },
    handleChange3 (value, type) {
      if (type === 'minute') {
        this.open3 = false
      }
    },
    notBeforeDate (date) {
      return date < new Date().setDate(new Date().getDate() - 1)
    },
    notBeforeDate1 (date) {
      return date < new Date(this.form.date)
    },
    init () {
      if (this.$store.state.option1 && this.$store.state.stations1 && this.$store.state.cars1) {
        this.date_mask_local = this.$store.state.option.date_mask
        this.lang = this.$store.state.lang
        this.langData = {
          days: [this.$store.state.option['sun-' + this.lang], this.$store.state.option['mon-' + this.lang], this.$store.state.option['tue-' + this.lang], this.$store.state.option['wed-' + this.lang], this.$store.state.option['thu-' + this.lang], this.$store.state.option['fri-' + this.lang], this.$store.state.option['sat-' + this.lang]],
          months: [this.$store.state.option['jan-' + this.lang], this.$store.state.option['fev-' + this.lang], this.$store.state.option['mar-' + this.lang], this.$store.state.option['apr-' + this.lang], this.$store.state.option['may-' + this.lang], this.$store.state.option['jun-' + this.lang], this.$store.state.option['jul-' + this.lang], this.$store.state.option['aug-' + this.lang], this.$store.state.option['sep-' + this.lang], this.$store.state.option['out-' + this.lang], this.$store.state.option['nov-' + this.lang], this.$store.state.option['dec-' + this.lang]]
        }
        this.form.time = new Date('2000/10/10 10:00:00')
        this.form.time1 = new Date('2000/10/10 10:00:00')
        this.estacoes = this.$store.state.stations
        this.slideshow = this.$store.state.option.slideshow ? this.$store.state.option.slideshow.split('##') : []
        this.cars = this.$store.state.cars
        if (this.$store.state.user1) {
          if (this.$store.state.user.role === 'client') {
            if (this.$store.state.drivers1) {
              this.drivers = this.$store.state.drivers
            } else {
              this._.delay(this.init, 100)
              return
            }
          } else {
            // if we are logged as driver, we set the user's birth date
            this.form.aniversario = this.$store.state.user.date_of_Birth
          }
        }
        this.SET_LOAD()
      } else {
        this._.delay(this.init, 100)
      }
    },
    onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = true
    },
    reservar () {
      // if (this.$store.state.option.date_format === 'YYYY-MM-DD' && !/[12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])/.test(this.form.aniversario) && !this.$store.state.user) {
      //   this.SET_AVISO(this.$store.state.option['erro-aniversario_pattern-' + this.lang] || 'Please insert the birthday date with the following pattern: yyyy-mm-dd')
      //   return
      // }
      this.formattedBirthDate = this.form.aniversario
      // set date of birth for user(driver)
      if (this.$store.state.user && this.$store.state.user.role === 'driver') {
        this.formattedBirthDate = this.$store.state.user.date_of_Birth
      }
      // verify which date format is used in vuex:
      if (!this.checkAndTransformBirthDate(this.form.aniversario)) {
        return
      } else {
        this.form.aniversario = this.birthDayFromMixin
      }
      let a = new Date(this.form.date)
      let b = new Date(this.form.date1)
      let a1 = new Date(this.form.time)
      let b1 = new Date(this.form.time1)
      let aniversario = new Date(this.formattedBirthDate)
      let x = 0
      if (this.form.levantamento) {
        if (this.form.date) {
          if (this.form.date1) {
            if (this.$store.state.user) {
              if (this.$store.state.user.role === 'client') {
                x = 'c'
              }
              if (this.$store.state.user.role === 'driver') {
                x = 'd'
              }
            }
            if ((((this.form.aniversario && this.form.driver === 'add') || (this.form.driver && this.form.driver !== 'add')) && x === 'c') || x === 'd' || (this.form.aniversario && !this.$store.state.user)) {
              // this.$localStorage.remove('reserva')
              this.$router.push('/reserved?l=' + this.form.levantamento + '&d=' + this.form.entrega + '&dt=' + a.getFullYear() + '/' + (+a.getMonth() + 1) + '/' + a.getDate() + ' ' + a1.getHours() + ':' + a1.getMinutes() + '&dt1=' + b.getFullYear() + '/' + (+b.getMonth() + 1) + '/' + b.getDate() + ' ' + b1.getHours() + ':' + b1.getMinutes() + '&b=' + aniversario.getFullYear() + '/' + (+aniversario.getMonth() + 1) + '/' + aniversario.getDate() + '&dd=' + this.form.driver + '&cd=' + this.form.condutor, () => {})
            } else {
              if (this.form.driver === 'add' || !this.$store.state.user) {
                this.SET_AVISO(this.$store.state.option['erro-aniversario-' + this.lang])
              } else {
                this.SET_AVISO(this.$store.state.option['erro-driver-' + this.lang])
              }
            }
          } else {
            this.SET_AVISO(this.$store.state.option['erro-devolucaoData-' + this.lang])
          }
        } else {
          this.SET_AVISO(this.$store.state.option['erro-levantamentoData-' + this.lang])
        }
      } else {
        this.SET_AVISO(this.$store.state.option['erro-levantamento-' + this.lang])
      }
    },
    setDriversBirthDay (driverID) {
      if (!driverID || driverID === 'add') {
        this.form.condutor = ''
        this.form.aniversario = ''
      } else {
        let selectedDriver = this.drivers.find(o => o.DriverID === driverID)
        this.form.aniversario = selectedDriver.Date_of_Birth
        this.form.condutor = selectedDriver.Driver_Name
      }
    }
  }
}
</script>

<style type="text/css" media="screen">
.vueperslide__content-wrapper:not(.vueperslide__content-wrapper--outside-top):not(.vueperslide__content-wrapper--outside-bottom) {top:90%;}
</style>
